<div class="u-theme-wrapper" [attr.data-theme]="theme()">
  <ng-content></ng-content>
</div>
